import React, { FunctionComponent, memo, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import ShareIcon from '../../../TeaserInfo/Share'

export type GalleryShareIconProps = {
    /**
     * callback function triggered when button is pressed
     *
     * @TJS-type function
     */
    onShare: () => void
}

const GalleryShareIcon: FunctionComponent<GalleryShareIconProps> = ({ onShare }): ReactElement => (
    <Grid noExpand horizontal>
        <Touchable onPress={onShare}>
            <Grid
                noExpand
                borderRadius={13}
                backgroundColor="onyx-opacity-50"
                width={26}
                height={26}
                centerVertical
                centerHorizontal
            >
                <ShareIcon fontSize="FS15" color="WHITE" />
            </Grid>
        </Touchable>
    </Grid>
)

export default memo(GalleryShareIcon)
